import ViewTranditionalRaffleWinnerTable from './viewTranditionalRaffleWinnerTable.container'

export default ViewTranditionalRaffleWinnerTable